import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'si-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RadioButtonComponent {
  @Input() text: string;
  @Input() styleClass: string;
  @Input() id: string;
  @Input() value: any;
  @Input() model: any;
  @Input() disabled: boolean;
  @Output() modelChange = new EventEmitter<any>();
  private _checked;

  get checked() {
    return this._checked;
  }

  @Input()
  set checked(val) {
    this._checked = val;
    setTimeout(() => {
      if ((val || val === '') && this.model == undefined) {
        this.setValueToModel();
      }
    });
  }

  onClickButton(): void {
    this.setValueToModel();
  }

  setValueToModel(): void {
    this.model = this.value;
    this.onChangeModel(this.model);
  }

  onChangeModel(model): void {
    this.modelChange.emit(model);
  }
}
